import { getCurrentInstance } from 'vue-demi';

export default function useStore() {
  return getCurrentInstance().proxy.$store;
}
